// function addProductToCart(product, info){
//     let formData = {
//         'items': [{
//         'id': product,
//         'quantity': 1
//         }]
//     };
//     fetch(window.Shopify.routes.root + 'cart/add.js', {
//         method: 'POST',
//         headers: {
//         'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(formData)
//     })
//     .then(response => {
//         return response.json();
//     })
//     .then(() => {
//         const message = info.querySelector('.message');
//             message.textContent = 'Great, the item is already in the cart'
//             message.classList = 'message good'

//     })
//     .catch((error) => {
//         console.error('Error:', error);
//     });

// }

// CART

let up = document.querySelectorAll("[data-btn-plus]");
let down = document.querySelectorAll("[data-btn-minus]");
let deleteItem = document.querySelectorAll(".mini-cart__order-delete");

up.forEach((item) => {
  item.addEventListener("click", (e) => {
    let product = e.target.closest(".mini-cart__order");
    let input = product.querySelector(".quantity-input");
    let key = product.getAttribute("data-key");
    let value = parseInt(input.value, 10);

    value = isNaN(value) ? 0 : value;
    value++;

    // input.value = value;
    changeItemTotalPrice(product, value);
    changeItemQuantity(key, value);
    changeCartQuantity("+");
  });
});

down.forEach((item) => {
  item.addEventListener("click", (e) => {
    let product = e.target.closest(".mini-cart__order");
    let input = product.querySelector(".quantity-input");
    let key = product.getAttribute("data-key");
    let value = parseInt(input.value, 10);

    if (value > 1) {
      value = isNaN(value) ? 1 : value;
      value--;
      // input.value = value;
      changeItemTotalPrice(product, value);
      changeItemQuantity(key, value);
      changeCartQuantity("-");
    } else {
      product.style.display = "none";
      changeItemQuantity(key, 0);
    }
  });
});

function changeCartQuantity(sign) {
  document.querySelectorAll(".cartt").forEach((cart) => {
    let currentValue = parseInt(cart.textContent, 10) || 0;
    if (sign === "+") {
      currentValue++;
    } else if (sign === "-" && currentValue > 0) {
      currentValue--;
    }
    cart.textContent = currentValue;
  });
}

deleteItem.forEach((item) => {
  item.addEventListener("click", (e) => {
    let product = e.target.closest(".mini-cart__order");
    let key = product.getAttribute("data-key");
    changeItemQuantity(key, 0);
    product.style.display = "none";
  });
});

function changeItemTotalPrice(item, quantity, isNew) {
  // let strokeElement = item.querySelector(".item-total");
  // if (!strokeElement) {
  //   console.error("Total price element not found in:", item);
  //   return;
  // }
  // console.log(item.getAttribute("data-price"));
  // let pricePerItem = parseFloat(item.getAttribute("data-price")) * 100;
  // let totalPrice = pricePerItem * quantity;
  // if (isNew) {
  //   strokeElement.innerHTML = `${(totalPrice.toFixed(2) / 100).toFixed(2)} CAD`;
  // }
  // strokeElement.innerHTML = `${(totalPrice.toFixed(2) / 100).toFixed(2)}`;
}

function strokeToNumber(stroke) {
  return parseFloat(stroke.replace(/[^0-9.]/g, ""));
}

function changeItemQuantity(key, quantity) {
  console.log("Updating item:", key, "to quantity:", quantity);

  let updates = {};
  updates[key] = quantity;

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Cart updated:", data);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
// let cartButton = document.querySelector(".cartt-button");

// cartButton.addEventListener("click", (e) => {
//   e.preventDefault();
//   showMiniCart();
// });

function showMiniCart() {
  let miniCart = document.querySelector(".mini-cart");
  miniCart.classList.add("active");

  document.removeEventListener("click", closeMiniCart);

  setTimeout(() => {
    document.addEventListener("click", closeMiniCart);
  }, 0);
}

function closeMiniCart(e) {
  let miniCart = document.querySelector(".mini-cart");
  // let cartButton = document.querySelector(".cartt-button");

  if (!miniCart.contains(e.target)) {
    miniCart.classList.remove("active");
    document.removeEventListener("click", closeMiniCart);
  }
}
let closeMiniCartButton = document.querySelector(".mini-cart__close");

closeMiniCartButton.addEventListener("click", (e) => {
  let miniCart = document.querySelector(".mini-cart");
  miniCart.classList.remove("active");
});
function updateCartItemCount() {
  let totalCount = 0;

  document.querySelectorAll(".mini-cart__order").forEach((item) => {
    let quantity = parseInt(item.querySelector(".quantity-input").value, 10);
    totalCount += quantity;
  });

  document.querySelector("#total-products").textContent = totalCount;
}

document.addEventListener("DOMContentLoaded", function () {
  console.log("cart-mini.js DOMContentLoaded");
  let addToMiniCart = document.querySelectorAll("button.add-to-mini-cart");

  addToMiniCart.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();

      let form = item.closest("form");
      if (form) {
        form.addEventListener("submit", (e) => {
          e.preventDefault();
        });
      }

      let product = e.target.closest(".add-to-mini-cart") || e.target;
      console.log(product);
      let key =
        product.getAttribute("data-key") || e.target.getAttribute("data-key");
      console.log(key);

      let productImage = product.getAttribute("data-image");
      let productTitle = product.getAttribute("data-title");
      let productPrice = product.getAttribute("data-price");
      console.log(productImage, productTitle, productPrice);

      let miniCart = document.querySelector(".mini-cart__orders");
      let keysRaw = miniCart.querySelectorAll("[data-key]");
      console.log(keysRaw);

      let keys = Array.from(keysRaw).map((key) => {
        let dataKey = key.getAttribute("data-key");
        return dataKey ? dataKey.split(":")[0] : "";
      });
      console.log(keys);
      let existingItem = Array.from(keysRaw).find((keyy) => {
        return keyy.getAttribute("data-key").split(":")[0] === key;
      });

      console.log(existingItem);

      if (existingItem) {
        console.log(existingItem);
        let quantityInput = existingItem.querySelector(".quantity-input");
        let currentQuantity = parseInt(quantityInput.value, 10);
        // if
        quantityInput.value = currentQuantity + 1;

        // let totalPriceElement = existingItem.querySelector(".item-total");
        // let updatedTotalPrice = (
        //   parseFloat(productPrice) *
        //   (currentQuantity + 1)
        // ).toFixed(2);
        // totalPriceElement.textContent = `${updatedTotalPrice}`;
        changeItemQuantity(key, currentQuantity + 1);
      } else {
        changeItemQuantity(key, 1);
        let cartItem = document.createElement("li");
        cartItem.classList.add("mini-cart__order");
        cartItem.setAttribute("data-key", key);
        cartItem.setAttribute("data-price", productPrice);
        cartItem.innerHTML = `
            <div class="card-product">
              <a class="card-product__image">
                <picture>
                  <source type="image/webp" srcset="${productImage}">
                  <img width="100" height="100" src="${productImage}" alt="${productTitle}">
                </picture>
              </a>

              <div class="card-product__info">
                <a class="card-product__title">${productTitle}</a>

                <div class="card-product__pricelist">
                  <span class="card-product__price-current">${productPrice}</span>
                </div>

                <div class="counter" data-counter="trash">
                  <div class="counter__button" data-btn-minus>
                    -
                  </div>
                  <input class="counter__value quantity-input" data-input-value type="text" value="1">
                  <div class="counter__button" data-btn-plus>
                    +
                  </div>
                </div>
              </div>
            </div>
        `;

        miniCart.prepend(cartItem);
        let up = cartItem.querySelector("[data-btn-plus]");
        let down = cartItem.querySelector("[data-btn-minus]");
        // let deleteItem = cartItem.querySelector(".mini-cart__order-delete");

        up.addEventListener("click", (e) => {
          let input = cartItem.querySelector(".quantity-input");
          let value = parseInt(input.value, 10);
          value = isNaN(value) ? 0 : value;
          value++;
          // input.value = value;
          changeItemTotalPrice(cartItem, value, true);
          changeItemQuantity(key, value);
          changeCartQuantity("+");
        });

        down.addEventListener("click", (e) => {
          let input = cartItem.querySelector(".quantity-input");
          let value = parseInt(input.value, 10);
          if (value > 1) {
            value = isNaN(value) ? 1 : value;
            value--;
            // input.value = value;
            changeItemTotalPrice(cartItem, value, true);
            changeItemQuantity(key, value);
            changeCartQuantity("-");
          } else {
            cartItem.remove();
            changeItemQuantity(key, 0);
          }
        });

        // deleteItem.addEventListener("click", () => {
        //   cartItem.remove();
        //   changeItemQuantity(key, 0);
        // });
      }

      updateCartItemCount();
      // changeItemQuantity(key, 1);
      showMiniCart();
    });
  });

  // let cartButton = document.querySelector(".cartt-button");
  // cartButton.addEventListener("click", (e) => {
  //   e.preventDefault();
  //   showMiniCart();
  // });
});
